import { useEffect, useMemo, useRef, useState } from "react";
import styles from "../index.module.less";
import { LoginType } from "../login";

export default function Tab({ active = LoginType.PWD, onChangeTab }) {
  const lineRef = useRef();
  const activeRef = useRef();

  const activeProp = useMemo(
    () => ({
      ref: activeRef,
      className: styles.active,
    }),
    []
  );

  const [current, setCurrent] = useState(active);

  useEffect(() => {
    setCurrent(active);
  }, [active, setCurrent]);

  useEffect(() => {
    if (activeRef.current) {
      lineRef.current.style.width = activeRef.current.offsetWidth + "px";
      lineRef.current.style.left = activeRef.current.offsetLeft + "px";
    }
  }, [current]);

  return (
    <div className={styles.loginTab}>
      <span
        {...(current === LoginType.PWD ? activeProp : {})}
        data-gd-click="button_click"
        data-button-name="登录"
        onClick={() => onChangeTab?.(LoginType.PWD)}
      >
        登录
      </span>
      <span
        {...(current === LoginType.REGISTER ? activeProp : {})}
        data-gd-click="button_click"
        data-button-name="注册"
        onClick={() => onChangeTab?.(LoginType.REGISTER)}
      >
        注册
      </span>
      <span ref={lineRef} className={styles.bottomLine}></span>
    </div>
  );
}
